import { useContext } from "react";
import { Typography, Grid } from "@mui/material";
import { useLocation, useHistory } from "react-router-dom";
import { Card, ContainerPaper } from "../../components";
import { ModuleContext } from "../../App";

const ProgramAssessments = () => {
  const location = useLocation();
  const history = useHistory();
  const { programCards, programName } = location.state || {};
  const { moduleSettings, setModuleSettings } = useContext(ModuleContext);

  if (!programCards) {
    return <div>Loading...</div>;
  }
  const btnStatus = (placement) => {
    // Safely check the Sittings array
    if (!placement.Sittings || placement.Sittings.length === 0) {
      return "Start";
    } else if (!placement.Sittings[0]?.isCompleted) {
      return "Resume";
    } else if (placement.Sittings[0]?.isCompleted) {
      return "Review";
    }
    return "";
  };

  function enableDiagnostic(placements) {
    const incomplete = placements?.find(
      (p) =>
        !p.Sittings || p.Sittings.length === 0 || !p.Sittings[0].isCompleted
    );
    return !incomplete;
  }

  const goToPlacement = (placement) => {
    const type = btnStatus(placement);

    setModuleSettings({
      ...moduleSettings,
      selectedModule: placement,
      open: false,
      ...(placement.diagnostic
        ? {
            moduleType: "Diagnostic",
          }
        : {
            moduleType: "Placement",
          }),
    });
    type === "Start"
      ? history.push("/instructions")
      : history.push("/placement-question");
  };

  return (
    <ContainerPaper>
      <Typography variant="h4" gutterBottom>
        {programName}
      </Typography>
      <Grid container spacing={3}>
        {programCards.map((card) => (
          <Grid key={card.id} item xs={12} sm={6} md={4}>
            <Card
              btnText={btnStatus(card)}
              cardTitle={card.name}
              btn
              assessment
              totalQuestions={card.totalQuestions}
              currentSitting={card.Sittings[0]}
              diagnostic={card.diagnostic}
              enableDiagnostic={() =>
                enableDiagnostic(programCards.filter((c) => !c.diagnostic))
              }
              goToPlacement={() => goToPlacement(card)}
            />
          </Grid>
        ))}
      </Grid>
    </ContainerPaper>
  );
};

export default ProgramAssessments;
